module.exports = __webpack_public_path__ + "img/U1F98A.d12c5a57.png";